"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useNavigator = exports.usePathNameList = exports.useMatch = void 0;
var react_1 = require("react");
var react_router_1 = require("react-router");
var pathname_to_pathlist_1 = require("./pathname-to-pathlist");
var useRouter = function () {
    return (0, react_1.useContext)(react_router_1.__RouterContext);
};
var useHistory = function () {
    var router = useRouter();
    return (0, react_1.useMemo)(function () { return router.history; }, [router.history]);
};
var useLocation = function () {
    var router = useRouter();
    return (0, react_1.useMemo)(function () { return router.location; }, [router.location]);
};
var useMatch = function () {
    var router = useRouter();
    return (0, react_1.useMemo)(function () { return router.match; }, [router.match]);
};
exports.useMatch = useMatch;
var usePathName = function () {
    var location = useLocation();
    return (0, react_1.useMemo)(function () { return location.pathname; }, [location.pathname]);
};
var usePathNameList = function () {
    var pathname = usePathName();
    return (0, react_1.useMemo)(function () { return (0, pathname_to_pathlist_1.pathnameToPathList)(pathname); }, [pathname]);
};
exports.usePathNameList = usePathNameList;
/**
 * `pathname !== history.location.pathname` is added to avoid a following warning:
 * "Hash history cannot PUSH the same path; a new entry will not be added to the history stack"
 */
var useNavigator = function () {
    var history = useHistory();
    var navigator = (0, react_1.useCallback)(function (pathname) {
        if (pathname !== history.location.pathname) {
            history.push(pathname);
        }
    }, [history]);
    return navigator;
};
exports.useNavigator = useNavigator;
